import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgCaretUpDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgCaretUp = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M7 14L12 8L17 14L7 14Z" fill="currentColor" />
  </svg>
));
